import React, { useEffect } from "react";
import _ from "lodash";
import { Box } from "@mui/material";
import { OcRoleFilter } from "oc/components";
import { useOcCurrentUserState, useOcRoleFilters } from "oc/hooks";
import useStyles from "oc/styles/filter-styles.style";
import { useTranslation } from "react-i18next";

type MyTimeExaminerDashboardRoleFilterProps = {
  loadQuery: () => void;
  loading: boolean;
  usersCount: number;
  roleFilterId: string;
};

export const MyTimeExaminerDahshboardRoleFilter = ({
  loadQuery,
  usersCount,
  roleFilterId,
}: MyTimeExaminerDashboardRoleFilterProps) => {
  const { contractCode: contract } = useOcCurrentUserState();
  const product = "MyTime";
  const role = "examiner";
  const classes = useStyles();

  const { t } = useTranslation();


  const {
    roleFilters,
    prevRoleFilters,
    resetRoleFilters,
    setPrevRoleFilters,
    handleAddFilter,
    handleRemoveFilter,
  } = useOcRoleFilters({ contract, product, role, id: roleFilterId });

  const buttonDisable = _.isEqual(roleFilters, prevRoleFilters);

  const handleLoadQuery = () => {
    loadQuery();
    setPrevRoleFilters(roleFilters);
  };

  const handleClearFilters = () => {
    resetRoleFilters();
  };

  useEffect(() => {
    loadQuery();
    setPrevRoleFilters(roleFilters);
  }, []); // eslint-disable-line

  return (
    <Box id="filter-container" className={classes.filterContainer}>
      <OcRoleFilter
        subtypeProps={{
          roleFilters: roleFilters,
          queryType: "notAdmin",
          handleAddItem: handleAddFilter,
          handleRemoveItem: handleRemoveFilter,
          product: "MyTime",
          role: "examiner",
          isCheckbox: true,
        }}
        summaryItems={[
          {
            label: "OC_TOTAL_COUNT_OF_EMPLOYEES",
            value: usersCount,
          },
        ]}
        buttonBarProps={{
          handlePrimaryButton: () => {
            handleLoadQuery();
          },
          primaryButtonDisabled: buttonDisable,
          handleRightButton: handleClearFilters,
          noLine: true,
          paddingTop: "10px",
          rightButtonText: t("OC_RESET"),
          rightButtonId: "cancel-button",
          rightButtonColor: "secondary",
          primaryButtonText: t("OC_FILTERING"),
          primaryButtonId: "filter-button",
        }}
      />
    </Box>
  );
};

export default MyTimeExaminerDahshboardRoleFilter;
